import { useEffect } from "react";

export const HerHappinessMyPeace = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px",
                        background: "#fff",
                        borderRadius: "8px",
                        maxWidth: "500px",
                        width: "95%",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img
                                src="/media/poemseng/her-happiness-my-peace.jpg"
                                alt=" Her Happiness, My Peace | Lone Wolf writes "
                                style={{
                                    width: "100%",
                                    height: "18rem",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "gray",
                                }}
                            />
                        </picture>
                    </div>

                    <h2 style={{ textAlign: "center", color:"red" }}>Her Happiness, My Peace</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        In the quiet space where our paths unwind,<br />
                        She’s found a dawn, a new peace of mind.  <br />
                        With a heart unburdened, lighter than before,  <br />
                        She steps into the world, ready to explore.<br />
                        <br />
                        Her spirit rises, like the sun’s first light,  <br />
                        Shining with joy, bold and bright.  <br />
                        Each new sunrise brings a fresh embrace,  <br />
                        She dances through life with elegant grace.<br />
                        <br />
                        It's poignant to see, yet beautiful too,  <br />
                        How she finds joy in skies so blue.  <br />
                        Though our journey together has come to an end, <br />
                        Her happiness blossoms around each bend.<br />
                        <br />
                        I wish her laughter in every new day,  <br />
                        And a love that lights her path along the way.  <br />
                        Though we’re apart, she’s close in my heart,  <br />
                        Her joy is a masterpiece, a work of art.<br />
                        <br />
                        May every dream she chases take flight,  <br />
                        In the canvas of dawn’s early light.  <br />
                        As she writes her new story, page by page,  <br />
                        I hope she finds peace and love at every stage.<br />
                        <br />
                        In the tapestry of her life’s endless grace,  <br />
                        May she always find her rightful place.  <br />
                        Though our paths have separated, I see,  <br />
                        Her happiness is a treasure, meant to be.<br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
